'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
function calcMenuHeight(styles) {
    return (Math.floor(parseFloat(styles.fontSize) *
        parseFloat(styles.lineHeight)) + parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) +
        parseFloat(styles.border) * 2);
}
exports.calcMenuHeight = calcMenuHeight;
//# sourceMappingURL=Functions.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/styles/Functions.js
// module id = 26
// module chunks = 0